<template>
    <div id="head-btn-wrapped" class="h-100">
        <v-btn class="head-btn h-100" id="head-btn" @click="isActive = !isActive" :class="{
                'overlay': isActive,
                'rounded-b-0 rounded-t-lg': isActive && $vuetify.display.lgAndUp,
                'rounded-0': isActive && $vuetify.display.mdAndDown
            }">
            <v-badge :content="0" color="green" v-if="logged" dot>
                <v-icon :icon="mdiAccountOutline" color="orange" size="x-large"/>
            </v-badge>
            <v-icon :icon="mdiAccountOutline" v-else color="black" size="x-large"/>
            <span v-if="$vuetify.display.mdAndUp" class="text-body-2 font-weight-thin mt-1" :class="{
                'text-decoration-underline': logged
            }">{{!$page.props.customer?.name ? $t('login-btn.account'): $page.props.customer?.name.split(' ')[0]}}</span>
        </v-btn>
        <v-overlay
            v-model="isActive"
            :attach="true"
            scrim="#000"
            :persistent="false"
            @click="$page.props.openLogin = false"
        >
            <v-menu
                v-model="isActive"
                :close-on-content-click="false"
                activator="parent"
                class="account-menu-wrap"
                :target="$vuetify.display.smAndDown? [0,0]: '#head-btn'"
                location="bottom end"
                transition="slide-y-transition"
                :offset="$vuetify.display.smAndDown ? [-12 - (infoBarHeight ? infoBarHeight + 4 : 0),0] : [0,64]"
                content-class="overflowing-menu"
            >
                <component :is="currentComponent" @close-menu="isActive = false"
                           @begin-login="loggingIn = true" v-click-outside="() => isActive = false"></component>
            </v-menu>
        </v-overlay>
    </div>
</template>
<script setup>
import {mdiAccountOutline} from "@mdi/js";
import {computed, ref, watch} from "vue";
import pinia from "../../../plugins/pinia.js";
import {useOverlayStore} from "./store/overlay.js";
import LoginWindow from "./LoginWindow.vue";
import UserMenu from "./UserMenu.vue";
import {usePage} from "@inertiajs/vue3";

defineProps({
    infoBarHeight: Number
})

const isActive = ref(false);
const loggingIn = ref(false);
const overlayStore = useOverlayStore(pinia);
watch(isActive, (now) => {
    overlayStore.overlayMenu = now;
    const container = document.getElementsByClassName('v-overlay-container');
    if(container.length && now){
        container[0].classList.add('has-login-overlay')
    }
    if (!now) {
        usePage().props.openLogin = false;
        if(container.length){
            container[0].classList.remove('has-login-overlay')
        }
    }
    if (!import.meta.env.SSR) {
        setTimeout(() => loggingIn.value = false, 200);
    }
});
watch(() => usePage().props.openLogin, (val) => {
    isActive.value = val;
}, {
    immediate: true
});
const logged = computed(() => {
    return !!usePage().props.customer?.id && !loggingIn.value
})
const currentComponent = computed(() => {
    if (logged.value) return UserMenu;
    return LoginWindow;
})

</script>
<style scoped lang="scss">
.head-btn {
    &.overlay {
        z-index: 3000;
        background-color: white;
    }
}

:deep(.overflowing-menu) {
    max-height: calc(100vh - 22%) !important;
}
</style>
